export const const_procesos = {
    dir_user: 'user_chs_plus',
    dir_socket: '/api_socket',
  
    //Nombre de variable de configuracion
    dir_config: 'config_servchs+',
    
  }